"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginOrchestrationService = void 0;
var LoginApi_1 = require("../api/LoginApi");
var LoginConsoleProps_1 = require("../components/LoginConsole/LoginConsoleProps");
var GetUserCurrentStateResponse_1 = require("../models/response/GetUserCurrentStateResponse");
var CommonFunctions_1 = require("../components/common/CommonFunctions/CommonFunctions");
var analytics_1 = require("@login/analytics");
var ReportingService_1 = require("../api/ReportingService");
var HalocAuthenticationService_1 = require("./HalocAuthenticationService");
var LoginOrchestrationService = /** @class */ (function () {
    function LoginOrchestrationService(loginConsole, loginConsoleProps) {
        this.loginConsole = loginConsole;
        this.loginConsoleProps = loginConsoleProps;
        this.halocAuthenticationService = new HalocAuthenticationService_1.default();
        this.loginApi = new LoginApi_1.default();
        this.commonFunctions = CommonFunctions_1.CommonFunctions.getInstance();
        this.initialState = null;
        this.loginPropData = this.loginConsoleProps.data;
    }
    LoginOrchestrationService.prototype.getNextState = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // This is easy to read, but pay atten to the async/await as this
                        // will get translated into some promises and resolves magically
                        console.log('LoginOrchestrationService.getNextState');
                        return [4 /*yield*/, this.doOrchestration(null)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result !== undefined && result.content !== undefined
                                && result.content.destinationPage !== undefined ?
                                result.content.destinationPage : GetUserCurrentStateResponse_1.UserDestinationPage.POSTAUTHERROR];
                }
            });
        });
    };
    LoginOrchestrationService.prototype.getNextStateForSelectedAccount = function (selectedAccount) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.doOrchestration(selectedAccount)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.content.destinationPage];
                }
            });
        });
    };
    LoginOrchestrationService.prototype.doOrchestration = function (selectedAccount) {
        return __awaiter(this, void 0, void 0, function () {
            var result, except_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log("LoginOrchestrationService.doOrchestration for" +
                            (" " + this.loginPropData.channel + "/" + this.loginPropData.flowType));
                        result = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.callOrchestration(selectedAccount)];
                    case 2:
                        result = _a.sent();
                        this.triggerRequiredReporting(selectedAccount, result);
                        return [4 /*yield*/, this.handleOrchestrationResult(result)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        except_1 = _a.sent();
                        console.error("LoginOrchestrationService::exception occured calling orchestrator", except_1);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/, result];
                }
            });
        });
    };
    LoginOrchestrationService.prototype.callOrchestration = function (selectedAccount) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loginApi.getUserCurrentState(this.loginPropData.channel, this.loginPropData.flowType, this.loginPropData.filter, selectedAccount)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    LoginOrchestrationService.prototype.triggerRequiredReporting = function (selectedAccount, result) {
        if (selectedAccount) {
            if (result.error) {
                this.loginConsole.reportingService.genericFireFormResponseEvent(true, result.error.message, result.error.errorId, analytics_1.ErrorTypeOption.Failure_User, 'Continue', ReportingService_1.PageEventCode.ACCOUNT_SELECTION, ReportingService_1.PageUrls.ACCOUNT_SELECTION);
            }
            else {
                this.loginConsole.reportingService.genericFireFormResponseEvent(false, 'success', '0', analytics_1.ErrorTypeOption.Success_Admit, 'Continue', ReportingService_1.PageEventCode.ACCOUNT_SELECTION, ReportingService_1.PageUrls.ACCOUNT_SELECTION);
            }
        }
    };
    LoginOrchestrationService.prototype.noAuthFlow = function () {
        return (this.loginConsoleProps.data.flowType === LoginConsoleProps_1.FlowType.NOAUTH_ACCOUNT_IN_FOCUS ||
            this.loginConsoleProps.data.flowType === LoginConsoleProps_1.FlowType.NOAUTH_SERVICES);
    };
    LoginOrchestrationService.prototype.handleOrchestrationResult = function (response) {
        /***HandlePostAuth*/
        if (response === undefined
            || response.content === undefined
            || response.content.destinationPage === undefined) {
            var errState = {
                userDestinationPage: GetUserCurrentStateResponse_1.UserDestinationPage.POSTAUTHERROR,
            };
            this.loginConsole.setState(errState);
            return;
        }
        /***HandlePostAuth*/
        // How to handle the various responses
        console.log('LoginOrchestrationServicehandleOrchestrationResult', response);
        var id = this.commonFunctions.removeSlidDomain(response.content.loggedInUserId);
        // These are always set if present.
        var newState = {
            loggedInUserId: id,
            userDestinationPage: response.content.destinationPage,
        };
        // track initial test
        if (this.initialState === null) {
            this.initialState = response.content.destinationPage;
            // For this test to set authenticated if needed
            if (response.content.destinationPage !== GetUserCurrentStateResponse_1.UserDestinationPage.LOGIN
                && !this.noAuthFlow()) {
                newState.authenticated = true;
            }
        }
        this.loginConsole.checkSendHALOFormResponse(response);
        // Process specific rules for these values IF NEEDED.
        switch (response.content.destinationPage) {
            case GetUserCurrentStateResponse_1.UserDestinationPage.ACCOUNT_SELECTION:
                this.processAccountSelectionPageResponse(newState, response);
                break;
            case GetUserCurrentStateResponse_1.UserDestinationPage.DONE:
                if (response.content.triggerRefresh) {
                    this.handleRefreshThenDone(newState);
                }
                else {
                    this.handleDone(newState);
                }
                return;
            case GetUserCurrentStateResponse_1.UserDestinationPage.LOGIN:
                newState.userDestinationPage = GetUserCurrentStateResponse_1.UserDestinationPage.HALO_LOGIN;
                break;
            case GetUserCurrentStateResponse_1.UserDestinationPage.PASSCODE_VALIDATION:
                this.processPasscodeValidationPageResponse(newState, response);
                break;
            case GetUserCurrentStateResponse_1.UserDestinationPage.NONE:
                break;
        }
        // Update state of the console.
        console.log("LoginOrchestrationService updating state for " +
            ("destination page " + newState.userDestinationPage), newState);
        this.loginConsole.setState(newState);
    };
    LoginOrchestrationService.prototype.handleRefreshThenDone = function (newState) {
        var _this = this;
        console.log("LoginOrchestrationService triggering refresh, then done");
        newState.userDestinationPage = GetUserCurrentStateResponse_1.UserDestinationPage.DONE;
        this.loginApi.profileSessionRefresh().then(function () {
            _this.handleDone(newState);
        }).catch(function () {
            _this.handleDone(newState);
        });
    };
    LoginOrchestrationService.prototype.handleDone = function (newState) {
        var _this = this;
        // We need to update state prior to calling triggerEndFlow
        // in order to get correct elements for triggerEndFlow
        console.log("LoginOrchestrationService updating state for " +
            ("destination page " + newState.userDestinationPage), newState);
        this.loginConsole.setState(newState, function () {
            _this.loginConsole.triggerEndFlow();
        });
    };
    // handle response value for account selection response.
    LoginOrchestrationService.prototype.processAccountSelectionPageResponse = function (newState, response) {
        newState.accountList = response.content.asmAccountsList;
        newState.hasAccountSelection = true;
    };
    // handle response value for passcode validation required repsonse
    LoginOrchestrationService.prototype.processPasscodeValidationPageResponse = function (newState, response) {
        var account = response.content.asmAccountsList[0];
        /* const account = response.content.asmAccountsList[ 0 ];
         newState.asmIndex = account.asmIndex;
         newState.selectedMaskedBan = account.maskedBan;
         newState.selectedMaskedBan = account.maskedBan;*/
        newState.passcodeAccountList = response.content.asmAccountsList;
    };
    return LoginOrchestrationService;
}());
exports.LoginOrchestrationService = LoginOrchestrationService;
//# sourceMappingURL=LoginOrchestrationService.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/services/LoginOrchestrationService.js
// module id = 1687
// module chunks = 8